// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3sqYd","question":"Question_question__iqJAX","description":"Question_description__2dQTp"};